import { useAuth } from "./use-auth";

export function useCurrentUser() {
  const { user } = useAuth();

  return {
    userId: user?.id || "anonymous",
    sessionId: `session_${user?.id || "anon"}_${Date.now()}`,
    user,
  };
}
